<template lang="pug">
div
  .md-headline {{ title }}
  // Name
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.name.$invalid }')
    label Name
    md-input#input-name(v-model='entity.name', :maxlength='200')
    span.md-error(v-if='formSubmitted && !validations.name.required') This field is required
    span.md-error(v-if='formSubmitted && validations.name.required && !validations.name.isUnique && !validations.name.$pending') Must be unique
  // Short Description
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.shortDescription.$invalid }')
    label Short Description
    span.md-error(v-if='formSubmitted && !validations.shortDescription.required') This field is required
    md-textarea#input-short-description(v-model='entity.shortDescription', :maxlength='200')
  // Long Description
  md-input-container
    label Long Description
    md-textarea#input-long-description(v-model='entity.longDescription', :maxlength='500')
  // Tags
  md-chips#input-chips(v-model='entity.tags', :md-max='15', md-input-placeholder='Tags...')
    template(slot-scope='chip')
      span {{ chip.value }}
  span.error-tags(v-if='formSubmitted && !validations.tags.required', :style="{ color: '#EA431F'}") Tags field is required. Write down one and press ENTER to create a new tag.
  // Genres
  md-layout
    genre-selector#series-dropdown(v-model='entity.genres', :multiple='true', :show-required-error='formSubmitted && !validations.genres.required')
  //- br
  // Mini serie selector
  //- md-checkbox(v-model='entity.isMiniSerie') Is mini-series
</template>

<script>
  import PropertiesForm from '../../shared-components/forms/PropertiesForm.vue';
  import GenreSelector from '../../shared-components/genre/GenresFormSelector.vue';
  import genreService from '../../services/genreService';

  export default {
    components: {
      PropertiesForm,
      GenreSelector
    },
    props: {
      title: {
        type: String,
        default: 'Metadata'
      },
      entity: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        required: true
      },
      validations: {
        type: Object,
        required: true
      }
    },
    data(){
      return {
        genres: [...genreService.getSupportedGenres()]
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-controls {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/SerieForm.vue